import { apiFetch } from './client';

export interface DashboardStats {
  totalParkingSpots: number;
  activeUsages: number;
  pendingRequests: number;
  availableSpots: number;
  totalUsages: number;
}

export type LeaderboardPeriod = 'week' | 'month' | 'all';
export type LeaderboardCategoryKey = 'available' | 'borrowed';

export interface LeaderboardEntry {
  rank: number;
  userId: string;
  displayName: string;
  photoUrl: string | null;
  score: number;
  isCurrentUser: boolean;
}

export interface LeaderboardCategory {
  key: LeaderboardCategoryKey;
  title: string;
  unit: string;
  entries: LeaderboardEntry[];
  currentUser: LeaderboardEntry | null;
}

export interface DashboardLeaderboard {
  period: LeaderboardPeriod;
  condominiumId: string;
  categories: LeaderboardCategory[];
}

export const dashboardKeys = {
  all: ['dashboard'] as const,
  stats: (period: LeaderboardPeriod = 'all') =>
    [...dashboardKeys.all, 'stats', period] as const,
  leaderboard: (condominiumId: string, period: LeaderboardPeriod) =>
    [...dashboardKeys.all, 'leaderboard', condominiumId, period] as const,
};

export function getDashboardStats(period: LeaderboardPeriod = 'all'): Promise<DashboardStats> {
  const params = new URLSearchParams({ period });
  return apiFetch<DashboardStats>(`/dashboard/stats?${params}`);
}

export function getDashboardLeaderboard(
  condominiumId: string,
  period: LeaderboardPeriod = 'all',
): Promise<DashboardLeaderboard> {
  const params = new URLSearchParams({
    condominiumId,
    period,
  });
  return apiFetch<DashboardLeaderboard>(`/dashboard/leaderboard?${params}`);
}
